import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BalancesAsOfToolTip from 'src/components/Shared/BalancesAsOfToolTip/BalancesAsOfToolTip';
import FullPageLoader from 'src/components/Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from 'src/components/Shared/StepsPageBackground/StepsPageBackground';
import * as AppData from 'src/redux/modules/applicationData/applicationData.selectors';
import {
  isLoaderVisible as _isLoaderVisible,
  shouldResetScrollPosition,
} from 'src/redux/modules/autoExchange/selectors';
import ExcessiveTradingPolicyNote from 'src/components/Shared/ExcessiveTradingPolicyNote/ExcessiveTradingPolicyNote';
import { selectExchangeType } from 'src/redux/modules/exchangeTransaction/actions';
import { getExchangeToExistingLoadFailed } from 'src/redux/modules/exchangeTransaction/selectors';
import { resetAutoExchangeSubmit } from 'src/redux/modules/executeAutoExchange/executeAutoExchange.module';
import {
  getValidationFailed,
  shouldChangeURL as maybeChangeURL,
} from 'src/redux/modules/executeAutoExchange/selectors';
import * as AllFunds from 'src/redux/modules/funds/AllFunds/allFunds.selectors';
import { ExchangeType } from 'src/settings/settings';
import { scrollElementIntoFullView } from 'src/utils/dom-utils';
import { appendBasePath } from 'src/utils/nav.utils';
import AutoExchangeSteps from '../Steps';
import { useErrorCheck } from './useErrorCheck';
import If from '../../../Shared/If/If';
import {
  didPersonalInformationFail,
  getDateOfBirth,
  getIsNotForeignAddress,
} from '../../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from 'src/redux/modules/authentication/authentication.module.selectors';

export interface AutoExchangeLandingProps {
  isCorporateAccountType?: boolean;
}

export const AutoExchangeLanding: React.VFC<AutoExchangeLandingProps> = ({
  isCorporateAccountType,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isIFrame: boolean = useSelector(isEmbeddedInIFrame);
  const customerWebViewEnabled: boolean = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRepEnabled: boolean = useSelector(isSalesforceRep);
  const shouldChangeURL = useSelector(maybeChangeURL);
  const shouldScroll = useSelector(shouldResetScrollPosition);
  const isFundsLoading = useSelector(AllFunds.getIsLoading);
  const isLoaderVisible = useSelector(_isLoaderVisible);
  const hasAppFailed = useSelector(AppData.getHasFailed);
  const dateOfBirth = useSelector(getDateOfBirth);
  const personalInfoFailed = useSelector(didPersonalInformationFail);
  const isNotForeignAddress = useSelector(getIsNotForeignAddress);

  const hasExchangeToExistingLoadFailed = useSelector(
    getExchangeToExistingLoadFailed
  );
  const hasValidationFailed = useSelector(getValidationFailed);

  useEffect(() => {
    if (shouldChangeURL) {
      //todo move this to a saga
      history.push(appendBasePath('/automatic/exchange/confirm'));
    }
  }, [history, shouldChangeURL]);

  useEffect(() => {
    // dispatch select ExchangeType Recurring
    dispatch(selectExchangeType(ExchangeType.RECURRING));
  }, [dispatch]);

  // should we scroll into view if validation error?
  useEffect(() => {
    if (shouldScroll) {
      scrollElementIntoFullView('recurring-exchange-page-container');
    }
  }, [shouldScroll]);

  const { hasError, errorType } = useErrorCheck({
    hasAppFailed,
    hasExchangeToExistingLoadFailed,
    hasTransactionFailed: false,
    hasValidationFailed,
    isCorporateAccountType,
    dateOfBirth,
    personalInfoFailed,
    isNotForeignAddress,
  });
  return (
    <div id="recurring-exchange-page-container">
      <FullPageLoader
        {...{ errorType, hasError }}
        isVisible={isLoaderVisible || isFundsLoading}
        messages={[]}
        onRetry={() => dispatch(resetAutoExchangeSubmit())}
      />
      <If
        test={
          !(isIFrame || (!customerWebViewEnabled && isSalesforceRepEnabled))
        }
      >
        <StepsPageBackground />
      </If>
      <div className="container">
        <AutoExchangeSteps />
        <BalancesAsOfToolTip />
        <ExcessiveTradingPolicyNote />
        <p style={{ color: '#000', position: 'relative', bottom: '10px' }}>
          2791649
        </p>
      </div>
    </div>
  );
};
